<template>
  <b-modal
    :id="id"
    v-model="aboutIntroModel"
    hide-header
    hide-footer
    no-stacking
    :no-close-on-backdrop="noCloseOnBackdrop"
    centered
  >
    <div class="success-body">
      <span
        v-if="showXButton"
        class="close-ico"
        @click="handleDismissClickWithType('x')"
      >
        <img src="@/assets/img/home/close-circle-icon.png" alt="" />
      </span>
      <img
        v-if="showBalloons"
        class="ballon-img"
        src="@/assets/img/home/success-image.png"
        alt=""
      />
      <h3 @click="handleGoToAboutIntroHome">
        <b-img v-bind="iconImgProps" rounded alt="Rounded image" />
        {{ appName }}
      </h3>
      <div class="main">
        <b-carousel
          :ref="slideId"
          :id="slideId"
          v-model="slide"
          :interval="interval"
          :controls="controls"
          :indicators="indicators"
          background="#FFFFFF"
          :img-height="viewHeight"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!---About 0-->
          <b-carousel-slide name="0">
            <template #img>
              <about-intro-content
                :height="viewHeight"
                img-src="/assets/img/appwelcome.jpg"
                :policy-path-url="selectedPolicyURLPath"
              />
            </template>
          </b-carousel-slide>
          <!---Tutorial 1-->
          <b-carousel-slide name="1">
            <template #img>
              <view-tutorial :height="viewHeight" />
            </template>
          </b-carousel-slide>
          <!---Policies 2-->
          <b-carousel-slide name="2">
            <template #img>
              <view-policy
                :height="viewHeight"
                :policy-path-url="selectedPolicyURLPath"
              />
            </template>
          </b-carousel-slide>
          <!---Credits 3-->
          <b-carousel-slide name="3">
            <template #img>
              <view-credits :height="viewHeight" />
            </template>
          </b-carousel-slide>
          <!---Leaderboard 4-->
          <b-carousel-slide name="4">
            <template #img>
              <view-leaderboard :height="viewHeight" />
            </template>
          </b-carousel-slide>
        </b-carousel>
        <p class="mt-4">
          {{ txtMsgIntro }}
        </p>
        <p v-if="false" class="mt-4">
          Slide #: {{ slide }}<br />
          Sliding: {{ sliding }}
        </p>
      </div>
      <p v-if="resource.versionNumber" style="text-align: center">
        V{{ resource.versionNumber }}
        <b-link
          v-if="resource.versionHistory"
          v-b-popover.focus="resource.versionHistory"
        >
          changes
        </b-link>
      </p>
      <div class="policies">
        <b-link @click="handleGoToSlidePolicyWith('/policy/terms')"
          >Terms</b-link
        >
        |
        <b-link @click="handleGoToSlidePolicyWith('/policy/privacy')"
          >Privacy</b-link
        >
        |
        <b-link @click="handleGoToSlidePolicyWith('/policy/data')">Data</b-link>
        |
        <b-link @click="handleGoToSlideCredits">Credits</b-link>
      </div>
      <div class="action-btns">
        <b-button
          variant="primary btn-round-fill"
          @click.prevent="handleGoToSlideTutorial"
        >
          {{ txtBtnShowTutorial }}
        </b-button>
        <b-link
          style="float: right; padding-right: 25px"
          @click="handleDismissClickWithType('ok')"
        >
          Ok, Got It
        </b-link>
      </div>
      <div v-if="showEmailMessage" class="send-list">
        {{ txtInviteEmail }}
      </div>
    </div>
  </b-modal>
</template>

<script>
import EventLog from "@/mixins/resourceBlocks/EventLog";
import AboutIntroContent from "./aboutintroContent";
import ViewTutorial from "./tutorial";
import ViewCredits from "./credits";
import ViewPolicy from "./policy";
import ViewLeaderboard from "./leaderboard";
export default {
  name: "AboutIntro",
  mixins: [EventLog],
  components: {
    AboutIntroContent,
    ViewTutorial,
    ViewCredits,
    ViewPolicy,
    ViewLeaderboard
  },
  props: {
    id: {
      type: String,
      required: true
    },
    aboutIntroModel: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      default: () => {}
    },
    settings: {
      type: Object,
      default: () => {}
    },
    txtIntro: {
      type: String,
      required: false
    },
    txtAbout: {
      type: String,
      required: false
    },
    personaliseForUser: {
      //Uses the user's name in the template
      type: Boolean,
      default: true
    },
    showBalloons: {
      //displays balloon- can be special features later
      type: Boolean,
      default: false
    },
    showEmailMessage: {
      //displays Invite Email Message
      type: Boolean,
      default: false
    },
    showXButton: {
      //Shows the dismiss button on th eright
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      //Determines whether the app can close with outside click- can still track dat
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconImgProps() {
      if (this.resource.imgURL) {
        this.mainProps.src = this.resource.imgURL;
      }
      return this.mainProps;
    },
    appName() {
      return this.resource.name ? this.resource.name : "AWESOME App";
    },
    txtMsgIntro() {
      return this.txtIntro ? this.txtIntro : `We are thrilled to have you join our community. ${this.appName} has been
          designed with you in mind, and we can't wait to show you how it can
          enhance your life. Welcome aboard, and enjoy the journey!`;
    },
    txtInviteEmail() {
      return `Please check your email (including spam folder) for an invite letter.`;
    },
    txtMsgAbout() {
      return this.txtAbout ? this.txtAbout : `This is the about for ${this.appName} `;
    },
    policyTermsURL() {
      return "/policy/privacy";
    },
    policyPrivacyURL() {
      return "/policy/privacy";
    },
    policyDateURL() {
      return "/policy/privacy";
    },
    txtBtnShowTutorial() {
      return `Watch Tutorial`;
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    handleGoToAboutIntroHome() {
      this.$refs[this.slideId].setSlide(0);

      this.handleEventLog({
        name: "aboutIntro.goto",
        payload: { home: 0 },
        level: "info"
      });
    },
    handleGoToSlideTutorial() {
      this.$refs[this.slideId].setSlide(1);

      this.handleEventLog({
        name: "aboutIntro.goto",
        payload: { tutorial: 1 },
        level: "info"
      });
    },
    handleGoToSlidePolicyWith(policyURLPath) {
      this.selectedPolicyURLPath = policyURLPath;
      this.$refs[this.slideId].setSlide(2);

      this.handleEventLog({
        name: "aboutIntro.goto",
        payload: { policy: 2 },
        level: "info"
      });
    },
    handleGoToSlideCredits() {
      this.$refs[this.slideId].setSlide(3);

      this.handleEventLog({
        name: "aboutIntro.goto",
        payload: { credits: 3 },
        level: "info"
      });
    },
    handleDismissClickWithType(dismissType) {
      this.$bvModal.hide(this.id);

      this.handleAboutIntroSeen(dismissType);
    },
    handleAboutIntroSeen(dismissType) {
      if (this.settings) {
        this.settings.hasSeenAboutIntro = true;
        this.$emit("update-settings");
      }

      this.handleEventLog({
        name: "aboutIntro.seen",
        payload: { dismissType: dismissType },
        level: "info"
      });
    }
  },
  data() {
    return {
      viewHeight: 250,
      /** SLIDE **/
      slideId: "aboutIntroSlides",
      interval: 0,
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      selectedPolicyURLPath: "/policy/terms",
      /** IMG **/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      },
      contactEmail: "help@ponyengine.com",
      contactPhone: "help@ponyengine.com"
    };
  }
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  z-index: 1040 !important;
}
.modal-content {
  margin: 2px auto;
  z-index: 1100 !important;
}

.success-body {
  position: relative;
  .close-ico {
    position: absolute;
    top: 0px;
    right: 0px;
    cursor: pointer;
  }
  .ballon-img {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, -100%);
  }
  h3 {
    padding-top: 40px;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0a111a;
    text-align: center;
    margin-bottom: 0;
    cursor: pointer;
  }
  .main {
    margin-top: 22px;
    font-weight: normal;
    font-size: 20px;
    line-height: 33px;
    text-align: center;
    color: #52595e;

    .position {
      height: 37px;
      background: #65ea82;
      box-shadow: 0px 4px 16px rgba(101, 234, 130, 0.4);
      border-radius: 32px;
      //display: flex;
      //justify-content: center;
      //align-items: center;
      padding: 0 10px;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 33px;
      text-align: center;
      color: #ffffff;
    }
  }
  .policies {
    margin-top: 13px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 33px;
    text-align: center;
    color: #52595e;
  }
  .action-btns {
    margin-top: 13px;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 33px;
    color: #52595e;
  }
  .send-list {
    margin-top: 22px;
    font-style: italic;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #52595e;
    padding-bottom: 36px;
  }
  .policies :hover {
    box-shadow: none;
  }
  .action-btns :hover {
    box-shadow: none;
  }
}
</style>
